import React from 'react';
import { NavLink } from 'react-router-dom';

export default function NavLinkToggle({ altTo, ...props }) {
  const to = props.to === props.location.pathname ? altTo : props.to;

  return (
    <NavLink {...props} to={to}>
      {props.children}
    </NavLink>
  );
}
NavLinkToggle.defaultProps = {
  altTo: '/',
};



// WEBPACK FOOTER //
// ./src/components/NavLinkToggle.js